import React, { useEffect, useMemo, useRef } from "react"
import ContentLayoutHeader from "../../../components/layouts/ContentLayoutHeader.layout"
import PrimaryButton from "../../../components/molecules/buttons/PrimaryButton.molecule"
import DropdownClientInplace from "../components/DropdownClientInplace.compound"
import useReportFiltersContext from "../../../hooks/contextConsumers/useReportFiltersContext.hook"
import IosShareIcon from "@mui/icons-material/IosShare"
import { CLIENT_SPRINT_STATES } from "../../../consts/modules/clientReport.consts"
import { toBase64Url } from "../../../utils/strings.utils"

function getVisibleViews(map, prefix = "") {
  const result = []

  Object.entries(map).forEach(([key, value]) => {
    const fullKey = prefix ? `${prefix}.${key}` : key

    if (typeof value === "boolean") {
      if (value) result.push(fullKey)
    } else if (typeof value === "object" && value !== null) {
      result.push(...getVisibleViews(value, fullKey))
    }
  })

  return result
}

const ClientReportHeader = ({
  selectedPeriod,
  visibleMap,
  setIsModalGroupClientSprintsVisible = () => {},
  period,
}) => {
  const dropdownProjectRef = useRef(null)
  const {
    clientReportClients,
    clientReportSelectedClient,
    setClientReportSelectedClient,
    setIsClientReportSelectedClientBillable,
    setClientReportSelectedClientCode,
    setClientReportSelectedClientName,
    setClientReportSelectedClientLogo,
  } = useReportFiltersContext()

  const clients = useMemo(() => {
    return clientReportClients.map((client) => ({
      id: client.clientId,
      name: client.name,
      code: client.code,
      isBillable: client.isBillable,
      clientLogo: client.clientLogo,
    }))
  }, [clientReportClients])

  function updateSelectedClientInfo() {
    const selectedClient = clients.find(
      (client) => client.id === clientReportSelectedClient
    )

    setIsClientReportSelectedClientBillable(selectedClient?.isBillable || false)
    setClientReportSelectedClientCode(selectedClient?.code || "")
    setClientReportSelectedClientName(selectedClient?.name || "")
    setClientReportSelectedClientLogo(selectedClient?.clientLogo || "")
  }

  useEffect(() => {
    if (clientReportClients.length === 0) return

    updateSelectedClientInfo()
  }, [clientReportSelectedClient])

  const subtitleTemplate = () => {
    return (
      <DropdownClientInplace
        value={clientReportSelectedClient}
        onChange={(e) => {
          setClientReportSelectedClient(e.value)
        }}
        options={clients}
        filter
        dropdownInputProps={(inputProps) => ({
          autoFocus: true,
          className: "w-full",
          onKeyDown: (e) => {
            inputProps.filterInputKeyDown(e)
          },
        })}
        dropdownRef={dropdownProjectRef}
      />
    )
  }
  const shareButtonProps = {
    icon: <IosShareIcon />,
    className: "h-fit",
    disabled: selectedPeriod?.state === CLIENT_SPRINT_STATES.IN_PROGRESS,
    onClick: async () => {
      const reportTokenPayload = {
        periodId: selectedPeriod?.id,
        clientId: clientReportSelectedClient,
        periodType: period.toUpperCase(),
      }
      const reportToken = toBase64Url(JSON.stringify(reportTokenPayload))

      const visibleViews = getVisibleViews(visibleMap)

      const params = new URLSearchParams({
        t: reportToken,
        v: toBase64Url(JSON.stringify(visibleViews)),
        p: toBase64Url(period),
      })

      window.open(`/client-report?${params.toString()}`, "_blank")
    },
  }

  const groupSprintsButtonProps = {
    label: "Agrupar sprints",
    className: "h-fit",
    btnType: "outlined",
    onClick: () => {
      setIsModalGroupClientSprintsVisible(true)
    },
  }

  const shareButton = <PrimaryButton {...shareButtonProps} />

  return (
    <ContentLayoutHeader
      title="Reporte de cliente"
      subtitle={subtitleTemplate()}
      buttonProps={groupSprintsButtonProps}
      extraContent={shareButton}
      disabled={selectedPeriod?.state !== CLIENT_SPRINT_STATES.IN_PROGRESS}
    />
  )
}

export default ClientReportHeader
